// Shared admin-panel role constants/helpers. Centralizes the "admin"/"staff"
// string comparisons that were previously duplicated (with inconsistent ==
// checks) across ~10 files.
export const ROLES = {
    ADMIN: 'admin',
    STAFF: 'staff',
};

export const isAdminRole = (role) => role === ROLES.ADMIN;
export const isStaffRole = (role) => role === ROLES.STAFF;
